module.exports = __webpack_public_path__ + "static/media/99gal21.30a8cf30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/99gal/99gal21.jpg
// module id = 78
// module chunks = 0